module.exports = __webpack_public_path__ + "img/logo-icon.fc919681.png";